<template>
  <Screen>
    <AppBar :title="title" :showBackButton="true" />
    <Breadcrumbs
      :links="[
        {
          to: $route('admin.support.index'),
          title: 'Support tickets',
        },
      ]"
      :title="`Details of ticket #${$route().params.id}`"
    />
    <div class="card card-body" v-if="ticket.id">
      <div class="row">
        <div class="col-lg-6">
          <h3 class="mb-3">Details</h3>
          <div class="table-responsive">
            <table class="table">
              <tr>
                <th>Ticket ID</th>
                <th>#{{ ticket.id }}</th>
              </tr>
              <tr>
                <th>Status</th>
                <td>
                  <span
                    class="badge badge-pill"
                    :class="[
                      ticket.resolved ? 'badge-success' : 'badge-danger',
                    ]"
                  >
                    {{ ticket.resolved ? "Resolved" : "Open" }}
                  </span>
                </td>
              </tr>
              <tr>
                <th>User</th>
                <th>
                  {{ ticket.user.name }}
                  <inertia-link
                    :href="
                      $route('admin.users.details', {
                        id: ticket.user.id,
                      })
                    "
                    class="ml-2"
                  >
                    <small>View</small>
                    <small class="fas fa-external-link-alt"></small>
                  </inertia-link>
                </th>
              </tr>
              <tr>
                <th>User mobile</th>
                <td>
                  <a
                    :href="`tel:${ticket.user.mobile}`"
                    v-text="ticket.user.mobile"
                  ></a>
                </td>
              </tr>
              <tr>
                <th>User email</th>
                <td>
                  <a
                    :href="`mailto:${ticket.user.email}`"
                    v-text="ticket.user.email"
                  ></a>
                </td>
              </tr>
              <tr>
                <th>Message/Query</th>
                <td>{{ ticket.message }}</td>
              </tr>
              <tr>
                <th>Created at</th>
                <td>{{ ticket.created_at_human }}</td>
              </tr>
              <tr>
                <th>Updated at</th>
                <td>{{ ticket.updated_at_human }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="col-lg-6">
          <hr class="d-block d-lg-none" />
          <h3 class="mb-3">Response</h3>
          <div class="table-responsive" v-if="ticket.resolved">
            <table class="table">
              <tr>
                <th>Responded by</th>
                <th>
                  {{ ticket.responded_by.name }}
                  <inertia-link
                    :href="
                      $route('admin.users.details', {
                        id: ticket.responded_by.id,
                      })
                    "
                    class="ml-2"
                  >
                    <small>View</small>
                    <small class="fas fa-external-link-alt"></small>
                  </inertia-link>
                </th>
              </tr>
              <tr>
                <th>Resolved at</th>
                <td>{{ ticket.responded_at_human }}</td>
              </tr>
              <tr>
                <th>Response</th>
                <td>{{ ticket.response }}</td>
              </tr>
            </table>
          </div>
          <form
            v-else-if="formSet"
            action=""
            method="post"
            @submit.prevent="submit"
          >
            <hr />
            <TextBox
              type="textarea"
              :rows="5"
              name="response"
              v-model="form.response"
              :disabled="form.processing"
              :error="form.errors.response"
            />
            <div class="mt-4">
              <button
                class="btn btn-primary w-25"
                type="submit"
                :disabled="form.processing"
                @click.prevent="submit"
              >
                <div
                  class="spinner-border spinner-border-sm"
                  role="status"
                  v-if="form.processing"
                ></div>
                <span v-else>Submit</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Screen>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    formData: {
      type: [Object, Array],
      default: () => {},
    },
    submitUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {},
      formSet: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.form = this.$inertia.form(this.formData);
      setTimeout(() => {
        this.formSet = true;
      });
    });
  },
  methods: {
    submit() {
      this.form.post(this.submitUrl, {
        onSuccess: () => this.form.reset(),
      });
    },
  },
  computed: {
    ticket() {
      return this.data.data || {};
    },
    title() {
      if (this.ticket.id) {
        return `Support ticket from '${this.ticket.user.name}' #${this.ticket.id}`;
      }

      return `Support ticket #${this.data.id}`;
    },
  },
};
</script>